import * as type from './type';

const initialState = {
  data: [],
  metadata: {},
  obj: {},
  isCreate: false,
  isUpdate: false,
  loading: false,
  isDelete: false,
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case type.GET_UNIT_LIST:
      return {
        ...state,
        data: action.data.data,
        metadata: action.data.metadata,
      };

    case type.GET_UNIT_ITEM:
      return {
        ...state,
        obj: action.data,
      };

    case type.UNIT_IS_CREATE:
      return {
        ...state,
        isCreate: action.data,
      };

    case type.UNIT_LOADING:
      return {
        ...state,
        loading: action.data,
      };

    case type.UNIT_IS_UPDATE:
      return {
        ...state,
        isUpdate: action.data,
      };

    case type.UNIT_IS_DELETE:
      return {
        ...state,
        isDelete: action.data,
      };
    default:
      return state;
  }
};
